<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    :class="contextClassName"
  >
    <path
      d="M12.351 17.9767L7.84817 13.0773L20 13.0773V10.9225L7.84817 10.9225L12.351 6.02335L10.9296 4.5L4 12L10.9296 19.5L12.351 17.9767Z"
    />
  </svg>
</template>

<script setup lang="ts">
  interface IProps {
    direction?: 'left' | 'right' | 'up' | 'down';
  }

  const props = withDefaults(defineProps<IProps>(), {
    direction: 'left',
  });

  const contextClassName = computed((): string => {
    return (() => {
      switch (props.direction) {
        case 'right':
          return 'rotate-180';
        case 'up':
          return 'rotate-90';
        case 'down':
          return '-rotate-90';
        default:
          return '';
      }
    })();
  });
</script>
